import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ForumIcon from '@mui/icons-material/Forum';
import { config } from '../config.js';

const HIGHLIGHTS = [
  { icon: StorefrontIcon, label: 'Vitrine do condomínio', text: 'Ofertas de vizinhos e parceiros' },
  { icon: ConfirmationNumberIcon, label: 'Vouchers', text: 'Descontos só para moradores' },
  { icon: EventAvailableIcon, label: 'Agenda', text: 'Serviços com horário marcado' },
  { icon: ForumIcon, label: 'Triagem por IA', text: 'O grupo organizado sozinho' },
];

export default function Hero() {
  return (
    <Box component="section" sx={{ pt: { xs: 6, md: 10 }, pb: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
          <Grid size={{ xs: 12, md: 7 }}>
            <Stack spacing={3}>
              <Chip
                label="Gratuito para moradores e condomínios"
                color="secondary"
                variant="outlined"
                sx={{ alignSelf: 'flex-start' }}
              />

              <Typography variant="h1" sx={{ fontSize: { xs: 38, sm: 48, md: 60 } }}>
                O clube de compras{' '}
                <Box component="span" sx={{ color: 'secondary.main' }}>
                  do seu condomínio
                </Box>
              </Typography>

              <Typography variant="subtitle1" color="text.secondary" sx={{ maxWidth: 620, fontSize: 18 }}>
                O que hoje se perde no meio do grupo de WhatsApp vira uma vitrine organizada:
                produtos de vizinhos, serviços de rotina e ofertas de fornecedores aprovados pelo
                síndico. Reclamações e sugestões seguem para a administração, separadas da parte
                comercial.
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button href={config.appUrl} variant="contained" color="secondary" size="large">
                  Acessar meu condomínio
                </Button>
                <Button href="#condominios" variant="outlined" color="inherit" size="large">
                  Sou fornecedor
                </Button>
              </Stack>

              <Typography variant="body2" color="text.secondary">
                Sem taxa para o condomínio. Sem contrato de fidelidade para o fornecedor.
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, md: 5 }}>
            <Stack spacing={2}>
              {HIGHLIGHTS.map(({ icon: Icon, label, text }) => (
                <Card key={label} elevation={0}>
                  <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center', py: 2.25 }}>
                    <Box
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: 2.5,
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: 'rgba(245,185,59,0.14)',
                        color: 'secondary.main',
                        flexShrink: 0,
                      }}
                    >
                      <Icon />
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        {label}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {text}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
